export enum CompensationReason {
  CounterOffer = 'Counter-offer',
  RegularPerfomanceEvaluation = 'Regular perfomance evaluation',
  TitlePromotion = 'Title promotion',
}
